import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import * as Sentry from '@sentry/angular';
import { environment } from './environment/environment';

// Initialize Sentry only in production
if (environment.production) {
  Sentry.init({
    dsn: 'https://6611001edd3009d79830f552fe9136ad@o4510074271760384.ingest.us.sentry.io/4510080087949312',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    environment: 'production',
  });
}

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err)
);
